// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS104: Avoid inline assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
let Classroom
const CocoModel = require('./CocoModel')
const schema = require('schemas/models/classroom.schema')
const utils = require('../core/utils')
const levelUtils = require('../core/levelUtils')
const { findNextLevelsBySession, getLevelsDataByOriginals } = require('ozaria/site/common/ozariaUtils')
const { checkIfProjectComplete } = require('../lib/ai-projects-helper')
const coursesHelper = require('../lib/coursesHelper')
const User = require('models/User')
const Level = require('models/Level')
const api = require('core/api')
const ClassroomLib = require('./ClassroomLib')
const Users = require('collections/Users')
const classroomUtils = require('app/lib/classroom-utils')
const prepaids = require('core/store/modules/prepaids').default

module.exports = (Classroom = (function () {
  Classroom = class Classroom extends CocoModel {
    static initClass () {
      this.className = 'Classroom'
      this.schema = schema
      this.prototype.urlRoot = '/db/classroom'
    }

    initialize () {
      this.listenTo(this, 'change:aceConfig', this.capitalizeLanguageName)
      return super.initialize(...arguments)
    }

    parse (obj) {
      if (obj._id) {
        // It's just the classroom object
        return obj
      } else {
        // It's a compound response with other stuff too
        this.owner = new User(obj.owner)
        return obj.data
      }
    }

    capitalizeLanguageName () {
      const language = __guard__(this.get('aceConfig'), x => x.language)
      this.capitalLanguage = utils.capitalLanguages[language]
      return this.capitalLanguage
    }

    joinWithCode (code, opts) {
      let url
      if ((code.length === 14) && (code.split('-').length === 3)) {
        url = this.urlRoot + '/join-by-activation-code'
      } else {
        url = this.urlRoot + '/~/members'
      }
      const options = {
        url,
        type: 'POST',
        data: { code },
        success: () => this.trigger('join:success'),
        error: () => this.trigger('join:error')
      }
      _.extend(options, opts)
      return this.fetch(options)
    }

    fetchByCode (code, opts) {
      const options = {
        url: _.result(this, 'url'),
        data: { code, 'with-owner': true }
      }
      _.extend(options, opts)
      return this.fetch(options)
    }

    getLevelNumber (levelID, defaultNumber, courseID) {
      // deal with duplicated levels in different course
      if (!this.levelNumberMap) {
        this.levelNumberMap = {}
        const language = this.get('aceConfig')?.language
        for (const course of (this.get('courses') || [])) {
          const levels = []
          for (const level of course.levels) {
            if (level.original) {
              if ((language != null) && (level.primerLanguage === language)) { continue }
              levels.push({ key: level.original, practice: level.practice != null ? level.practice : false, assessment: level.assessment != null ? level.assessment : false })
            }
          }
          _.assign(this.levelNumberMap, utils.createLevelNumberMap(levels, course._id))
        }
      }

      if (courseID && this.levelNumberMap[`${courseID}:${levelID}`]) {
        return this.levelNumberMap[`${courseID}:${levelID}`]
      }
      return this.levelNumberMap[levelID] != null ? this.levelNumberMap[levelID] : defaultNumber
    }

    removeMember (userID, opts) {
      const options = {
        url: _.result(this, 'url') + `/members/${userID}`,
        type: 'DELETE'
      }
      _.extend(options, opts)
      return this.fetch(options)
    }

    setStudentPassword (student, password) {
      const classroomID = this.id
      return new Promise((resolve, reject) => {
        return $.ajax({
          url: `/db/classroom/${classroomID}/members/${student.id}/reset-password`,
          method: 'POST',
          data: { password },
          success: () => {
            this.trigger('save-password:success')
            return resolve()
          },
          error: response => {
            this.trigger('save-password:error', response.responseJSON)
            return reject(response.responseJSON)
          }
        })
      })
    }

    getLevels (options) {
      // options: courseID, withoutLadderLevels, projectLevels, assessmentLevels, levelsCollection
      // TODO: find a way to get the i18n in here so that level names can be translated (Courses don't include in their denormalized copy of levels)
      if (options == null) { options = {} }
      const Levels = require('collections/Levels')
      const courses = this.get('courses')
      if (!courses) { return new Levels() }
      const levelObjects = []
      for (const course of Array.from(courses)) {
        if (options.courseID && (options.courseID !== course._id)) {
          continue
        }
        if (options.levelsCollection) {
          for (const level of Array.from(course.levels)) {
            const matchedLevel = options.levelsCollection.findWhere({ original: level.original })
            levelObjects.push((matchedLevel != null ? matchedLevel.attributes : undefined) || matchedLevel)
          }
        } else {
          levelObjects.push(course.levels)
        }
      }
      const levels = new Levels(_.flatten(levelObjects))
      const language = __guard__(this.get('aceConfig'), x => x.language)
      if (language) { levels.remove(levels.filter(level => level.get('primerLanguage') === language)) }
      if (options.withoutLadderLevels) {
        levels.remove(levels.filter(level => level.isLadder()))
      }
      if (options.projectLevels) {
        levels.remove(levels.filter(level => level.get('shareable') !== 'project'))
      }
      if (options.assessmentLevels) {
        levels.remove(levels.filter(level => !level.get('assessment')))
      }
      return levels
    }

    getLevelsByModules () {
      const courseModuleLevelsMap = {}
      for (const course of Array.from(this.get('courses'))) {
        const courseLevels = this.getLevels({ courseID: course._id }).models
        const capstoneLevel = courseLevels.find(l => l.isCapstone())
        const isCh1 = course._id === utils.courseIDs.CHAPTER_ONE
        courseModuleLevelsMap[course._id] = {
          modules: levelUtils.buildLevelsListByModule(courseLevels, isCh1)
        }
        if (capstoneLevel) {
          courseModuleLevelsMap[course._id].capstone = capstoneLevel
        }
      }
      return courseModuleLevelsMap
    }

    fetchIntroContentDataForLevels (courseModuleLevelsMap) {
      let levels
      let introLevels = []
      for (const course of Array.from(this.get('courses'))) {
        for (const moduleNum in courseModuleLevelsMap[course._id].modules) {
          levels = courseModuleLevelsMap[course._id].modules[moduleNum]
          introLevels = introLevels.concat(levels.filter(l => l.get('introContent')))
        }
      }
      return api.levels.fetchIntroContent(introLevels)
        .then(introLevelContentMap => {
          return introLevels.forEach(l => {
            return utils.addIntroLevelContent(l, introLevelContentMap)
          })
        })
    }

    getLadderLevel (courseID) {
      const Levels = require('collections/Levels')
      const courses = this.get('courses')
      const course = _.findWhere(courses, { _id: courseID })
      if (!course) { return }
      const levels = new Levels(course.levels)
      return levels.find(l => l.isLadder())
    }

    getProjectLevel (courseID) {
      const Levels = require('collections/Levels')
      const courses = this.get('courses')
      const course = _.findWhere(courses, { _id: courseID })
      if (!course) { return }
      const levels = new Levels(course.levels)
      const projects = levels.filter(l => l.isProject())
      return projects[projects.length - 1]
    }

    findNextLevel (sessions, courseLevels) {
      const nextLevelOriginal = findNextLevelsBySession(sessions, courseLevels.models)
      return new Level(getLevelsDataByOriginals(courseLevels.models, [nextLevelOriginal])[0])
    }

    statsForSessions (sessions, courseID, levelsCollection) {
      let complete, left, nextLevel, nextLevelNumber
      if (levelsCollection == null) { levelsCollection = undefined }
      if (!sessions) { return null }
      sessions = sessions.models || sessions
      const arena = this.getLadderLevel(courseID)
      const project = this.getProjectLevel(courseID)
      const courseLevels = this.getLevels({ courseID, withoutLadderLevels: true, levelsCollection })
      const levelSessionMap = {}
      for (const session of Array.from(sessions)) {
        const original = session.get('level')?.original ?? session.get('scenario')
        levelSessionMap[original] = session
      }
      let currentIndex = -1
      let lastStarted = null
      let levelsTotal = 0
      let levelsLeft = 0
      let lastPlayed = null
      let lastPlayedNumber = null
      let playtime = 0
      const levels = []
      let linesOfCode = 0
      const userLevels = {}
      const levelsInCourse = new Set()
      const levelAttributesArr = courseLevels.models.map(l => l.attributes)
      for (let index = 0; index < courseLevels.models.length; index++) {
        let left2, left3
        const level = courseLevels.models[index]
        if (!level.get('practice') && !level.get('assessment')) { levelsTotal++ }
        complete = false
        const session = levelSessionMap[level.get('original')]
        if (session) {
          let left1
          complete = (left = session.get('state').complete) != null ? left : false
          playtime += (left1 = session.get('playtime')) != null ? left1 : 0
          linesOfCode += session.countOriginalLinesOfCode(level)
          lastPlayed = level
          lastPlayedNumber = this.getLevelNumber(level.get('original'), index + 1, courseID)
          if (complete) {
            currentIndex = index
          } else {
            lastStarted = level
            if (!level.get('practice') && !level.get('assessment')) { levelsLeft++ }
          }
        } else if (!(level.get('practice') || level.get('assessment'))) {
          levelsLeft++
        }
        const lockCheckOriginal = utils.findParentLevelOriginal(level.attributes, levelAttributesArr)
        levels.push({
          assessment: (left2 = level.get('assessment')) != null ? left2 : false,
          practice: (left3 = level.get('practice')) != null ? left3 : false,
          complete,
          optional: this.isStudentOnOptionalLevel(me.id, courseID, lockCheckOriginal),
          slug: level.get('slug'),
          original: level.get('original'),
        })
        if (!level.get('practice') && !level.get('assessment')) { levelsInCourse.add(level.get('original')) }
        userLevels[level.get('original')] = complete
      }
      lastPlayed = lastStarted != null ? lastStarted : lastPlayed
      if (lastPlayed != null ? lastPlayed.get('assessment') : undefined) { lastPlayedNumber = '' }
      let needsPractice = false
      let nextIndex = 0
      if (currentIndex >= 0) {
        let left4
        const currentLevel = courseLevels.models[currentIndex]
        const currentPlaytime = (left4 = __guard__(levelSessionMap[currentLevel.get('original')], x => x.get('playtime'))) != null ? left4 : 0
        let thresholdFactor = 1
        if (utils.JUNIOR_COURSE_IDS.includes(courseID) && me.get('aceConfig')?.codeFormat === 'text-code') {
          // when Junior text-code, we allow user to have double time to type compare to drag the blocks
          thresholdFactor = 2
        }
        needsPractice = utils.needsPractice(currentPlaytime, currentLevel.get('practiceThresholdMinutes') * thresholdFactor) && !currentLevel.get('assessment')
        if (utils.isCodeCombat || !utils.orderedCourseIDs.includes(courseID)) {
          nextIndex = utils.findNextLevel(levels.map(level => {
            const lockCheckOriginal = utils.findParentLevelOriginal(level, levels)
            return { ...level, locked: this.isStudentOnLockedLevel(me.id, courseID, lockCheckOriginal) }
          }), currentIndex, needsPractice)
        }
      }
      if (utils.OZ_COURSE_IDS.includes(courseID)) {
        const nextLevelOriginal = findNextLevelsBySession(sessions, courseLevels.models, null, this, courseID)
        nextLevel = new Level(getLevelsDataByOriginals(courseLevels.models, [nextLevelOriginal])[0])
      } else {
        if (currentIndex === -1) {
          nextIndex = utils.findNextLevel(levels.map(level => {
            const lockCheckOriginal = utils.findParentLevelOriginal(level, levels)
            return { ...level, locked: this.isStudentOnLockedLevel(me.id, courseID, lockCheckOriginal) }
          }), currentIndex, needsPractice)
        }
        nextLevel = courseLevels.models[nextIndex]
        if (levelsLeft === 0) { nextLevel = arena }
        if (nextLevel == null) { nextLevel = _.find(courseLevels.models, level => !__guard__(__guard__(levelSessionMap[level.get('original')], x2 => x2.get('state')), x1 => x1.complete)) }
      }
      if (nextLevel) {
        nextLevelNumber = this.getLevelNumber(nextLevel.get('original'), nextIndex + 1, courseID)
      }
      // eslint-disable-next-line no-unused-vars
      const [_userStarted, courseComplete, _totalComplete] = Array.from(coursesHelper.hasUserCompletedCourse(userLevels, levelsInCourse))

      const stats = {
        levels: {
          size: levelsTotal,
          left: levelsLeft,
          done: levelsLeft === 0,
          numDone: levelsTotal - levelsLeft,
          pctDone: ((100 * (levelsTotal - levelsLeft)) / levelsTotal).toFixed(1) + '%',
          lastPlayed,
          lastPlayedNumber,
          next: nextLevel,
          nextNumber: nextLevelNumber,
          first: courseLevels.first(),
          arena,
          project
        },
        playtime,
        linesOfCode,
        courseComplete
      }
      return stats
    }

    statsForAIProjects (sessions, courseId) {
      const emptyResults = { levels: { size: 0, left: 0, done: true, numDone: 0, pctDone: '0.0%', completedCapstones: 0 }, courseComplete: false, totalMessages: 0 }
      const course = this.get('courses')?.find(c => c._id === courseId)
      if (!course) {
        return emptyResults
      }
      const scenarios = course.levels
      if (!scenarios || !scenarios.length) {
        return emptyResults
      }
      const allProjects = sessions.models.map(p => p.toJSON())
      const projectsByScenario = _.groupBy(allProjects, 'scenario')
      const levelsTotal = scenarios.length
      let levelsLeft = levelsTotal
      let completedCapstones = 0
      let totalMessages = 0
      for (const scenarioOriginal in projectsByScenario) {
        const projects = projectsByScenario[scenarioOriginal]
        const scenario = scenarios.find(s => s.original === scenarioOriginal)
        if (!scenario) {
          continue
        }
        const isCapstone = utils.isCapstone(scenario.mode)
        const isComplete = checkIfProjectComplete(scenario, projects)
        totalMessages += projects.reduce((acc, p) => acc + (p.totalChatMessages || 0), 0)
        if (isComplete) {
          levelsLeft -= 1

          if (isCapstone) {
            completedCapstones += 1
          }
        }
      }
      const courseComplete = levelsLeft === 0
      const stats = {
        levels: {
          size: levelsTotal,
          left: levelsLeft,
          done: levelsLeft === 0,
          numDone: levelsTotal - levelsLeft,
          pctDone: ((100 * (levelsTotal - levelsLeft)) / levelsTotal).toFixed(1) + '%',
          completedCapstones,
        },
        totalMessages,
        courseComplete,
      }
      return stats
    }

    fetchForCourseInstance (courseInstanceID, options) {
      if (options == null) { options = {} }
      if (!courseInstanceID) { return }
      const CourseInstance = require('models/CourseInstance')
      const courseInstance = _.isString(courseInstanceID) ? new CourseInstance({ _id: courseInstanceID }) : courseInstanceID
      options = _.extend(options, {
        url: _.result(courseInstance, 'url') + '/classroom'
      })
      return this.fetch(options)
    }

    inviteMembers (emails, recaptchaResponseToken, options) {
      if (options == null) { options = {} }
      if (options.data == null) { options.data = {} }
      options.data.emails = emails
      options.data.recaptchaResponseToken = recaptchaResponseToken
      options.url = this.url() + '/invite-members'
      options.type = 'POST'
      return this.fetch(options)
    }

    getSortedCourses () {
      let left
      return utils.sortCourses((left = this.get('courses')) != null ? left : [])
    }

    isStudentOnLockedCourse (studentID, courseID) {
      return Classroom.isStudentOnLockedCourse(this.attributes, studentID, courseID)
    }

    isStudentOnLockedLevel (studentID, courseID, levelOriginal) {
      return Classroom.isModifierActiveForStudent(this.attributes, studentID, courseID, levelOriginal, 'locked')
    }

    isStudentOnOptionalLevel (studentID, courseID, levelOriginal) {
      return Classroom.isModifierActiveForStudent(this.attributes, studentID, courseID, levelOriginal, 'optional')
    }

    isStudentOnSkippedLevel (studentID, courseID, levelOriginal) {
      const lockedByTeacher = Classroom.isModifierActiveForStudent(this.attributes, studentID, courseID, levelOriginal, 'locked')
      const optional = Classroom.isModifierActiveForStudent(this.attributes, studentID, courseID, levelOriginal, 'optional')
      return lockedByTeacher && optional
    }

    updateCourses (options) {
      if (options == null) { options = {} }
      options.url = this.url() + '/update-courses'
      options.type = 'POST'
      return this.fetch(options)
    }

    hasAssessments (options) {
      if (options == null) { options = {} }
      if (options.courseId) {
        const course = _.find(this.get('courses'), c => c._id === options.courseId)
        if (!course) { return false }
        return _.any(course.levels, { assessment: true })
      }
      return _.any(this.get('courses'), course => _.any(course.levels, { assessment: true }))
    }

    isGoogleClassroom () { return __guard__(this.get('googleClassroomId'), x => x.length) > 0 }

    hasReadPermission (options) {
      if (options == null) { options = { showNoty: false } }
      const showNoty = options.showNoty || false
      const result = classroomUtils.hasPermission('read', {
        ownerId: this.get('ownerID'),
        permissions: this.get('permissions')
      }) || this.hasWritePermission()
      if (!result && showNoty) {
        noty({ text: 'teacher.not_read_permission', type: 'error', timeout: 4000, killer: true })
      }
      return result
    }

    hasWritePermission (options) {
      if (options == null) { options = { showNoty: false } }
      const showNoty = options.showNoty || false
      const result = classroomUtils.hasPermission('write', {
        ownerId: this.get('ownerID'),
        permissions: this.get('permissions')
      })
      if (!result && showNoty) {
        noty({ text: $.i18n.t('teacher.not_write_permission'), type: 'error', timeout: 4000, killer: true })
      }
      return result
    }

    isOwner () {
      return (me.id === this.get('ownerID')) || me.isAdmin()
    }

    getDisplayPermission () {
      if (this.isOwner()) {
        return
      }
      if (this.hasWritePermission()) {
        return classroomUtils.getDisplayPermission('write')
      } else if (this.hasReadPermission()) {
        return classroomUtils.getDisplayPermission('read')
      }
    }

    revokeStudentLicenses () {
      const students = new Users()
      return Promise.all(students.fetchForClassroom(this, { removeDeleted: true, data: { project: 'firstName,lastName,name,email,products,deleted' } }))
        .then(() => {
          const studentsToRevoke = students.models.filter(student => (student.prepaidStatus() === 'enrolled') && (student.prepaidType() === 'course'))
          if (studentsToRevoke.length > 0) {
            return this.showRevokeConfirm(studentsToRevoke).then(revokeConfirmed => {
              let sharedClassroomId
              if (!revokeConfirmed) { return }

              if (!this.isOwner() && this.hasWritePermission()) {
                sharedClassroomId = this.id
              }

              return prepaids.actions.revokeLicenses(null, {
                members: students.models,
                sharedClassroomId,
                confirmed: true,
                updateUserProducts: true
              })
            })
          }
        })
    }

    showRevokeConfirm (studentsToRevoke) {
      return new Promise(function (resolve) {
        const notification = noty({
          text: studentsToRevoke.length + $.i18n.t('teacher.archive_revoke_confirm'),
          type: 'info',
          layout: 'top',
          buttons: [
            {
              addClass: 'btn btn-danger',
              text: $.i18n.t('teacher.archive_without_revoking'),
              onClick ($noty) {
                $noty.close()
                return resolve(false)
              }
            },
            {
              addClass: 'btn btn-primary',
              text: $.i18n.t('teacher.revoke_and_archive'),
              onClick ($noty) {
                $noty.close()
                return resolve(true)
              }
            }
          ]
        })
        return notification.$buttons.addClass('style-flat')
      })
    }

    static codeNinjaClassroomTypes () {
      return [
        { id: 'club-3-month', name: 'Club (3 Month)', disabled: true },
        { id: 'club-esports', name: 'Club Esports' },
        { id: 'club-hackstack', name: 'Club Hackstack' },
        { id: 'club-roblox', name: 'Club Roblox' },
        { id: 'club-ozaria', name: 'Club Ozaria' },
        { id: 'camp-week', name: 'Camp (1 Week)', disabled: true },
        { id: 'camp-esports', name: 'Camp Esports' },
        { id: 'camp-junior', name: 'Camp Junior' },
        { id: 'annual-plan', name: 'Annual', disabled: true },
        { id: 'annual-plan-cn-coco', name: 'Annual CodeCombat & CodeCombat Junior' },
      ]
    }

    isCodeNinjaClubCamp () {
      return Classroom.codeNinjaClassroomTypes().map(type => type.id).includes(this.get('type'))
    }
  }
  Classroom.initClass()
  return Classroom
})())

// Make ClassroomLib accessible as static methods.
_.assign(Classroom, ClassroomLib.default)

function __guard__ (value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
